import { AppThunk } from 'app/store'

import { list } from 'services/carriers'
import { slice } from './reducer'

export const {
  fetchCarriersStart,
  fetchCarriersSuccess,
  fetchCarriersFailed,
  createCarrier,
  searchUpdated,
} = slice.actions

export const fetchCarriers = (): AppThunk => async (dispatch, getState) => {
  dispatch(fetchCarriersStart())
  const search = getState()
  try {
    const data = await list(search.carriers.meta.search)
    dispatch(fetchCarriersSuccess(data))
  } catch (err) {
    dispatch(fetchCarriersFailed())
  }
}

export const updateSearch = (search: string): AppThunk => (dispatch) => {
  dispatch(searchUpdated(search))
}
